import { slideToDown } from '../../animations/router.animation';
import { Component, Input, EventEmitter, Output, ElementRef, Renderer2 } from '@angular/core';
export class LayoutComponent {
       titleText = 'Humadev Theme';
       titleImg: string;
       lazyLoadModule = false;
       nav: any = false;
       notification: any = false;
       logout = new EventEmitter();
      sidenavOpen = true;
/**
 * @param {?} elRef
 * @param {?} renderer
 */
constructor(
private elRef: ElementRef,
private renderer: Renderer2
      ){}
/**
 * @return {?}
 */
onLogout() {
            this.logout.emit();
      }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    // tslint:disable-next-line:component-selector
    selector: 'hd-layout',
    template: `
        <hd-main-toolbar
                [notification]="notification"
                (sidenavToggle)="sidenav.toggle()"
                (logout)="onLogout()"
                [titleText]="titleText"
                [titleImg]="titleImg">
        </hd-main-toolbar>
        <hd-sidenav #sidenav
                [opened]='sidenavOpen'
                (pageTitle)="pagebar.changePageTitle($event)"
                [lazyLoadModule]="lazyLoadModule"
                [nav]="nav">
                <hd-page-toolbar #pagebar></hd-page-toolbar>
                <div class='hd-page'>
                    <ng-content></ng-content>
                </div>
        </hd-sidenav>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'titleText': [{ type: Input },],
'titleImg': [{ type: Input },],
'lazyLoadModule': [{ type: Input },],
'nav': [{ type: Input },],
'notification': [{ type: Input },],
'logout': [{ type: Output },],
};
}

function LayoutComponent_tsickle_Closure_declarations() {
/** @type {?} */
LayoutComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LayoutComponent.ctorParameters;
/** @type {?} */
LayoutComponent.propDecorators;
/** @type {?} */
LayoutComponent.prototype.titleText;
/** @type {?} */
LayoutComponent.prototype.titleImg;
/** @type {?} */
LayoutComponent.prototype.lazyLoadModule;
/** @type {?} */
LayoutComponent.prototype.nav;
/** @type {?} */
LayoutComponent.prototype.notification;
/** @type {?} */
LayoutComponent.prototype.logout;
/** @type {?} */
LayoutComponent.prototype.sidenavOpen;
/** @type {?} */
LayoutComponent.prototype.elRef;
/** @type {?} */
LayoutComponent.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
